import { render, staticRenderFns } from "./PointSignin.vue?vue&type=template&id=7c56f758&scoped=true&"
import script from "./PointSignin.vue?vue&type=script&lang=js&"
export * from "./PointSignin.vue?vue&type=script&lang=js&"
import style0 from "./PointSignin.vue?vue&type=style&index=0&id=7c56f758&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c56f758",
  null
  
)

export default component.exports